import { render } from "./StepRappresentante.vue?vue&type=template&id=db4ce378&scoped=true"
import script from "./StepRappresentante.vue?vue&type=script&lang=js"
export * from "./StepRappresentante.vue?vue&type=script&lang=js"

import "./StepRappresentante.vue?vue&type=style&index=0&id=db4ce378&lang=css"
import "./StepRappresentante.vue?vue&type=style&index=1&id=db4ce378&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4ce378"]])

export default __exports__